import React from "react";

const GoDetailUrl = ({url}) => {

  return (
    <button className="btn btn-grid" onClick={()=>{window.open(url)}}>
      네이버 블로그 바로가기
    </button>
  );
};

export default GoDetailUrl;
